import { throttle } from 'lodash'
import { fabric } from 'fabric'
import { ref } from '@vue/composition-api'
import { useZoom, getCanvasSize } from '../utils/hooks'

export default class Shape {
    public origX: number
    public origY: number
    public canvas: fabric.Canvas
    public isDrawing: boolean

    public constructor(canvas: fabric.Canvas) {
        this.origX = 0
        this.origY = 0
        this.canvas = canvas
        this.isDrawing = false
        this.bindEvents()
    }

    public bindEvents() {
        const { onMouseWheel } = useZoom(ref(this.canvas))
        let backgroundImageWidth = 0
        let backgroundImageHeight = 0
        if (this.canvas.backgroundImage && (this.canvas.backgroundImage as fabric.Image).width) {
            backgroundImageWidth = (this.canvas.backgroundImage as fabric.Image).width as number
        }
        if (this.canvas.backgroundImage && (this.canvas.backgroundImage as fabric.Image).height) {
            backgroundImageHeight = (this.canvas.backgroundImage as fabric.Image).height as number
        }
        this.canvas.off('mouse:down')
        this.canvas.off('mouse:move')
        this.canvas.off('mouse:up')
        this.canvas.off('object:moving')
        this.canvas.off('object:scaling')
        this.canvas.off('mouse:wheel')

        this.canvas.on('mouse:down', event => {
            this.onMouseDown(event)
        })
        this.canvas.on(
            'mouse:move',
            throttle(event => {
                this.onMouseMove(event)
                // onMousemove(event)
            }, 100)
        )
        this.canvas.on('mouse:up', event => {
            this.onMouseUp(event)
        })
        this.canvas.on('object:moving', event => {
            const target = event.target as fabric.Object
            const { strokeWidth } = getCanvasSize(ref(this.canvas))
            const imgWidth = backgroundImageWidth
            const imgHeight = backgroundImageHeight
            const maxLeft = imgWidth - (target.width || 0) * (target.scaleX || 1)
            const maxTop = imgHeight - (target.height || 0) * (target.scaleY || 1)
            const targetLeft = target.left || 0
            const targetTop = target.top || 0
            if (targetLeft <= 0) {
                target.set({ left: 0 })
            } else if (targetLeft > maxLeft) {
                target.set({ left: maxLeft - strokeWidth })
            }

            if (targetTop <= 0) {
                target.set({ top: 0 })
            } else if (targetTop > maxTop) {
                target.set({ top: maxTop - strokeWidth })
            }

            target.setCoords()
            this.canvas.renderAll()
            this.disable()
        })
        this.canvas.on('object:scaling', event => {
            const target = (event.transform as any).target as any
            if (!target || target.type !== 'rect') {
                return
            }
            const imgWidth = backgroundImageWidth
            const imgHeight = backgroundImageHeight
            const targetLeft = target.left || 0
            const targetTop = target.top || 0
            const targetWidth = (target.width || 0) * (target.scaleX || 1)
            const targetHeight = (target.height || 0) * (target.scaleY || 1)

            if (imgWidth - targetLeft - targetWidth < 0) {
                target.set({ width: imgWidth - targetLeft, scaleX: 1 })
            }
            if (imgHeight - targetTop - targetHeight < 0) {
                target.set({ height: imgHeight - targetTop, scaleY: 1 })
            }

            if (targetLeft < 0) {
                target.set({ left: 0, scaleX: 1 })
                target.set({ width: targetLeft + targetWidth })
            }

            if (targetTop < 0) {
                target.set({ top: 0, scaleY: 1 })
                target.set({ height: targetTop + targetHeight })
            }

            target.setCoords()
            this.canvas.renderAll()
        })
        this.canvas.on('mouse:wheel', onMouseWheel)

        // 鼠标双击响应
        // this.canvas.on('mouse:dblclick', event => {
        // TODO
        // })
    }

    public onMouseUp(event: fabric.IEvent) {
        // console.log(event)
    }

    public onMouseMove(event: fabric.IEvent) {
        // console.log(event)
    }

    public onMouseDown(event: fabric.IEvent) {
        // console.log(event)
    }

    public isEnable() {
        return this.isDrawing
    }

    public enable() {
        this.canvas.selection = false
        this.isDrawing = true
    }

    public disable() {
        this.isDrawing = false
        this.canvas.selection = true
    }
}
